import React from 'react';
import { X } from 'lucide-react';
import {
  Box,
  DrawerBackdrop,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerPositioner,
  DrawerRoot,
  Flex,
  Portal,
  Text,
} from '@chakra-ui/react';

const modeCopy = {
  login: {
    eyebrow: 'SIGN IN',
    subtitle: 'Access your workspace without leaving the page.',
  },
  signup: {
    eyebrow: 'GET STARTED',
    subtitle: 'Create your account from the landing page and continue immediately.',
  },
};

export default function AuthDrawer({ mode, onClose, children }) {
  const copy = modeCopy[mode] ?? modeCopy.login;

  return (
    <DrawerRoot
      open={Boolean(mode)}
      placement="end"
      modal
      onOpenChange={(details) => {
        if (!details.open) {
          onClose();
        }
      }}
    >
      <Portal>
        <DrawerBackdrop bg="blackAlpha.600" backdropFilter="blur(6px)" />
        <DrawerPositioner>
          <DrawerContent
            position="relative"
            bg="app.surface"
            borderLeftWidth="1px"
            borderColor="landing.border"
            boxShadow="0 32px 96px rgba(11, 31, 58, 0.32)"
            maxW={{ base: '100vw', sm: '520px' }}
            overflow="hidden"
          >
            <Box
              position="absolute"
              top="0"
              left="0"
              right="0"
              h="168px"
              bg="linear-gradient(180deg, rgba(27,79,204,0.12) 0%, rgba(27,79,204,0) 100%)"
              pointerEvents="none"
            />

            <DrawerHeader
              position="relative"
              px={{ base: 5, md: 7 }}
              pt={{ base: 5, md: 6 }}
              pb={5}
              borderBottomWidth="1px"
              borderColor="landing.border"
            >
              <Flex align="start" justify="space-between" gap={4}>
                <Box>
                  <Text fontSize="xs" fontWeight="800" letterSpacing="0.08em" color="brand.primary">
                    {copy.eyebrow}
                  </Text>
                  <Text fontSize="sm" color="text.muted" mt={2} maxW="300px" lineHeight="1.6">
                    {copy.subtitle}
                  </Text>
                </Box>

                <Box
                  as="button"
                  type="button"
                  w="40px"
                  h="40px"
                  borderRadius="full"
                  borderWidth="1px"
                  borderColor="landing.border"
                  color="text.muted"
                  display="inline-flex"
                  alignItems="center"
                  justifyContent="center"
                  cursor="pointer"
                  transition="all 200ms"
                  _hover={{ bg: 'landing.surface', color: 'text.main', borderColor: 'brand.primary' }}
                  onClick={onClose}
                  aria-label="Close authentication drawer"
                >
                  <X size={18} />
                </Box>
              </Flex>
            </DrawerHeader>

            <DrawerBody px={{ base: 5, md: 7 }} py={{ base: 6, md: 7 }}>
              {children}
            </DrawerBody>
          </DrawerContent>
        </DrawerPositioner>
      </Portal>
    </DrawerRoot>
  );
}